import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'
import { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

import type { ContactSection } from '../types/_base'

export interface InfoState {
  contactSections: ContactSection[];
}

const initialState: InfoState = {
  contactSections: []
};

const infoSlice = createSlice({
  name: 'info',
  initialState,
  reducers: {
    setInfo(state, action: PayloadAction<{ contactSections: ContactSection[] }>) {
      console.log("#setInfo heard!")
      const { contactSections } = action.payload;
      state.contactSections = contactSections;
    },
  },
});

// export const getContactSectionByName = (state: RootState, name: string) => {
//   return state.info.contactSections.find(cs => cs.name === name);
// }

const selectContactSections = (state: RootState) => state.info.contactSections;

// helper to avoid DRY
const makeSortedSelector =
  (rankKey: 'mobileRank' | 'desktopRank') =>
    createSelector([selectContactSections], (sections: ContactSection[]) =>
      [...sections].sort(
        (a, b) => (a[rankKey] ?? 0) - (b[rankKey] ?? 0)
      )
    );

export const selectMobileSections  = makeSortedSelector('mobileRank');
export const selectDesktopSections = makeSortedSelector('desktopRank');

export const getContactSectionByName = (name: string) =>
  createSelector([selectContactSections], sections =>
    sections.find(cs => cs.name === name)
  );

export const { setInfo } = infoSlice.actions;
export default infoSlice.reducer;